/**
 * deliveryCopy.ts — the ONE wording for delivery's price on the journey's order
 * summaries (the plan screen's rail and the Delivery & payment rail).
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: journey look and feel
 * (2026-09-24, CTO — "show we do prices including delivery and show they don't
 * need to pay anything there").
 *
 * ⚠️ IT SAYS "Free" AND NOTHING ELSE — NO STRUCK-THROUGH "WAS" FIGURE, EVER.
 * Delivery is never priced or charged anywhere in this estate: no quote, hold,
 * payment link or invoice carries a delivery line (orders-service holds and
 * captures `monthlyPence` alone). prices-service's `deliveryFeePence` is a
 * MARGIN-MODEL input — what delivery costs US — and is read into no quote. So a
 * "Delivery £10 → −£10" line would advertise a saving against a price nobody has
 * ever been charged: a fictitious reference price, which the Digital Markets,
 * Competition and Consumers Act 2024 (Schedule 20) treats as a misleading
 * action, and which the CMA now fines directly. "Free" is simply true.
 *
 * If a delivery CHARGE is ever introduced, it arrives from the server on the
 * quote like every other figure (R41) — this file never grows a number.
 */
export const DELIVERY_SUMMARY_ROW = {
  label: 'Delivery',
  value: 'Free',
} as const;

/**
 * SHORT FORM of {@link DELIVERY_SUMMARY_ROW} — the checkout loader card's
 * delivery headline, "Free delivery" (2026-09-25, `checkoutLoaderContent.ts`).
 * BUILT from the row's own two words (its value, then its label), so it can say
 * nothing the order summaries do not, and it inherits this file's rule: a WORD,
 * never a figure, never a struck "was" price or a "saving" on delivery.
 */
export const FREE_DELIVERY = `${DELIVERY_SUMMARY_ROW.value} ${DELIVERY_SUMMARY_ROW.label.toLowerCase()}`;
